import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWindows as fabFaWindows,
  faApple as fabFaApple,
  faLinux as fabFaLinux,
} from '@fortawesome/free-brands-svg-icons';

import Drm from 'Components/Utility/Drm';
import ProductCover from 'Components/Utility/ProductCover';
import useViewport from 'Hooks/useViewport';

const GiftItemCard = ({
  item,
}) => {
  let drmPlatform = '';

  if (item.drm) {
    drmPlatform = Object.keys(item.drm).filter(p => item.drm[p])[0];
  }

  const { isAboveSm } = useViewport();

  return (
    <div
      className={classNames(
        'new-order-item',
        { 'comic-order-item': item.type === 'comic' || item.type === 'book' || item.type === 'audio' || item.type === 'video' },
        { 'software-order-item': item.display_type === 'software' },
      )}
    >
      {isAboveSm &&
        <ProductCover
          cover={item.cover}
          alt={`Product cover for ${item.name}`}
          displayType={item.display_type}
        />
      }

      <div className="order-item-details-container">
        <div className="name-icons-container">
          <div className="game-name">
            {item.isFreeProduct &&
              <FormattedMessage id="managegiftitemcard.isFreeProductBonus" defaultMessage="BONUS:" />
            } {item.name}
          </div>

          {item.bundleName &&
            <div className="additional-info">
              <FormattedMessage id="managegiftitemcard.bundle" defaultMessage="Bundle: {bundleName}" values={{ bundleName: item.bundleName }} />
            </div>
          }

          <div className="icons-container">
            {drmPlatform && drmPlatform !== 'drm_free' &&
              <Drm drmType={drmPlatform} />
            }
            {item.platforms &&
              <div>
                {item.platforms.windows &&
                  <FontAwesomeIcon icon={fabFaWindows} className="mr-2" />
                }
                {item.platforms.mac &&
                  <FontAwesomeIcon icon={fabFaApple} className="mr-2" />
                }
                {item.platforms.linux &&
                  <FontAwesomeIcon icon={fabFaLinux} className="mr-2" />
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

GiftItemCard.propTypes = {
  item: PropTypes.shape({}),
};

GiftItemCard.defaultProps = {
  item: {},
};

export default GiftItemCard;
